module.exports = __webpack_public_path__ + "img/benefit_super-bowl-experience.363a292d.jpg";